import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './hooks/useAuth'; // ✅ Changed from './hooks/useAuth'
import AppRoutes from './routes';

// Get the basename from the PUBLIC_URL environment variable.
// This tells react-router that all routes are prefixed with /skillstree.
const basename = process.env.PUBLIC_URL || '';

console.log(`App Version: ${process.env.REACT_APP_VERSION}`);
console.log(`Router basename: ${basename}`);
if (process.env.REACT_APP_VERSION) {
  localStorage.setItem('app_version', process.env.REACT_APP_VERSION);
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#009688',
    },
    secondary: {
      main: '#ff9800',
    },
  },
  typography: {
    fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
});


const AppContent: React.FC = () => {
  // ✅ Single source of truth for routing
  return <AppRoutes />;
};


function App() {
  return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router basename={basename}>
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        </Router>
      </ThemeProvider>
  );
}

export default App;
